var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Grid } from './DataGrid.styles';
import { getColumns } from '../utils';
var defaultProps = {
    rowProps: {},
    cellProps: {}
};
export var GridStateContext = React.createContext(defaultProps);
/**
 * The data grid delivers a flexible CSS grid. The number of nodes within the first row determines total number of columns.
 */
export var DataGrid = function (props) {
    var _a = React.useState(defaultProps), grid = _a[0], setGrid = _a[1];
    var children = props.children, gridProps = __rest(props, ["children"]);
    React.useLayoutEffect(function () {
        setGrid(__assign(__assign({}, defaultProps), gridProps));
    }, [props]);
    var columns = getColumns(props);
    return (React.createElement(Grid, __assign({}, props, { columns: columns }),
        React.createElement(GridStateContext.Provider, { value: grid }, props.children)));
};
//# sourceMappingURL=DataGrid.js.map